import { render, staticRenderFns } from "./hotList.vue?vue&type=template&id=a21b36b0&scoped=true"
import script from "./hotList.vue?vue&type=script&lang=js"
export * from "./hotList.vue?vue&type=script&lang=js"
import style0 from "./hotList.vue?vue&type=style&index=0&id=a21b36b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b36b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21b36b0')) {
      api.createRecord('a21b36b0', component.options)
    } else {
      api.reload('a21b36b0', component.options)
    }
    module.hot.accept("./hotList.vue?vue&type=template&id=a21b36b0&scoped=true", function () {
      api.rerender('a21b36b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/markManage/hotList.vue"
export default component.exports